import { Advertisement, Commercial, IconsRedirect } from "../Components"
import { useDataCollectionRequest } from "../Hooks"
import { BannersCards, BannersImgs, GridCards, MultiColumnAdversiment } from "../Section"
import { MainToHome, MainToHome2, MaintoHome3 } from "../Section/MainToHome"


export const Home = () => {

    const {dataCollectionRequest} = useDataCollectionRequest('banners/?tipo=PO', 'col')

    return (
        <div className={''}>
            <BannersImgs />
            {/* <MainToHome /> */}
            <div className="" style={{ margin: '2rem' }}></div>
            
            <IconsRedirect />

            <div className="" style={{ margin: '2rem' }}></div>

            <Commercial enableBanner={true} percent={'10%'} comercial={'DE DESCUENTO EN TODA LA TIENDA EN LINEA, !NO ESPERES MÁS¡'}/>

            <div className="" style={{ margin: '2rem' }}></div>

            <div className="container">
                <GridCards filters="?best_seller=true" />
            </div>

            <div className="" style={{ margin: '5rem' }}></div>
            <div className="">
                <MultiColumnAdversiment />
            </div>
            <div className="" style={{ margin: '6.5rem' }}></div>
            
            {/* <Advertisement title1={'¡Llevate lo que desees!'} title2={'!Con ofertas desde el 30%!'}/> */}

            <div className="container">
                <div className="row">
                    <div className="col-md-4 m-auto">
                        <img src={ dataCollectionRequest?.results[0]?.image } className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-8 m-auto">
                        <BannersCards filters="?new=True" />
                    </div>
                </div>
            </div>
            
            <Advertisement title1={'¡Ofertas en ropa de mujeres!'} title2={'!Llevatela a meses sin intereses!'}/> 

            {/* <div className="container">
                <GridCards filters="?best_seller=true" />
            </div>

            <Advertisement title1={'¡Ofertas en ropa de mujeres!'} title2={'!Llevatela a meses sin intereses!'}/> */}

            <div className="container">
                <div className="row">
                    <div className="col-md-8 order-1 order-md-0 m-auto">
                        <BannersCards filters="?more_expensive=True"/>
                    </div>
                    <div className="col-md-4 order-0 m-auto">
                        <img src={ dataCollectionRequest?.results[1]?.image } className="img-fluid " style={{ objectFit: 'cover' }} alt="" />
                    </div>
                </div>
            </div>

            <Advertisement title1={'¡Ofertas en ropa de mujeres!'} title2={'!Llevatela a meses sin intereses!'}/> 

            <div className="container">
                <div className="row">
                    <div className="col-md-4 m-auto">
                        <img src={ dataCollectionRequest?.results[2]?.image } className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-8 m-auto">
                        <BannersCards filters="?new=True" />
                    </div>
                </div>
            </div>

            <Advertisement title1={'¡Ofertas en ropa de mujeres!'} title2={'!Llevatela a meses sin intereses!'}/> 

            <div className="container">
                <div className="row">
                    <div className="col-md-8 order-1 order-md-0 m-auto">
                        <BannersCards filters="?new=True" />
                    </div>
                    <div className="col-md-4 order-0 m-auto">
                        <img src={ dataCollectionRequest?.results[3]?.image } className="img-fluid" alt="" />
                    </div>
                </div>
            </div>

        </div>
    )
}
